import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { withRouter } from "react-router";
import { withContext } from "../shared/withContext";
import { Link } from "react-router-dom";
import { Message } from "primereact/message";

interface Props {
    history: any;
}
interface State {
    email: string;
    password: string;
    failed: boolean;
}
class Registrieren extends Component<Props, State> {
    state = {
        email: "",
        password: "",
        failed: false,
    };

    render() {
        return (
            <div className="p-d-flex p-jc-center p-flex-column">
                {this.state.failed && (
                    <Message
                        severity="error"
                        text="Bitte überprüfen Sie Ihre Eingaben"
                    ></Message>
                )}
                <span className="p-float-label   p-mt-4 p-mx-auto">
                    <InputText
                        id="in"
                        value={this.state.email}
                        onChange={(e) =>
                            this.setState({ email: e.target.value })
                        }
                        className={this.state.failed ? "p-invalid" : ""}
                    />
                    <label htmlFor="in">E-Mail</label>
                </span>
                <span className="p-float-label   p-mt-4 p-mx-auto">
                    <Password
                        toggleMask
                        value={this.state.password}
                        onChange={(e) =>
                            this.setState({ password: e.target.value })
                        }
                        className={this.state.failed ? "p-invalid" : ""}
                    />
                    <label htmlFor="in">Neues Passwort</label>
                </span>
                <Link className="p-mx-auto p-mt-4" to="/login">
                    Sie haben schon ein Konto? Jetzt anmelden
                </Link>
                <br />

                <Button
                    label="Registrieren"
                    onClick={() =>
                        firebase
                            .auth()
                            .createUserWithEmailAndPassword(
                                this.state.email,
                                this.state.password
                            )
                            .then(() => this.props.history.push("/login/email"))
                            .catch((error) => this.setState({ failed: true }))
                    }
                />
            </div>
        );
    }
}
export const RegisterStandalone = Registrieren;
export default withRouter(withContext(Registrieren));
